export const hasRetrys = (operationName: string | undefined) => {
  if (operationName === 'CheckClientExists') return false;
  return true;
};
